// extracted by mini-css-extract-plugin
export default {"container":"G7zgTlOx","title":"Q6V60mSI"};